export const uuidv7 = () => {
  const ts = Date.now().toString(16).padStart(12, "0");
  const rand = crypto.getRandomValues(new Uint8Array(10));
  let hex = "";
  for (const b of rand) {
    hex += b.toString(16).padStart(2, "0");
  }
  return (
    ts.slice(0, 8) +
    "-" +
    ts.slice(8, 12) +
    "-7" +
    hex.slice(0, 3) +
    "-" +
    (8 | (parseInt(hex.slice(3, 4), 16) & 3)).toString(16) +
    hex.slice(4, 7) +
    "-" +
    hex.slice(7, 19)
  );
};
